module.exports = __webpack_public_path__ + "img/FINANCEPR8.babfd5b2.png";